<div class="smooth-scrolling">

  <app-responsive-searchbar-black-border *ngIf="productType != 'wishlist'"></app-responsive-searchbar-black-border>

  <!-- inner-pg-title START -->
  
  <div class="inner-pg-title">
    <div class="container">
      <h1>{{productType}}</h1>
    </div>
  </div>
  <!-- inner-pg-title END -->

  <!-- Shop Main START -->
  <div *ngIf="productType == 'supplements'">
  <section class="shop-main" *ngIf="supplimentProducts && supplimentProducts.length > 0">
    <div class="shop-wrap">

      <!-- Listing START -->
      <div class="services-lists">
        <div class="row" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100"
          (scrolled)="onScrollSupplimentProduct()">
          <div class="col-md-3 col-sm-6 item" *ngFor="let supplimentProduct of supplimentProducts; let i  = index" >
            <app-product-box [color]="supplimentProduct?.category?.color" [product]="supplimentProduct" [mAddUpdateCartModule]="mAddUpdateCartModule" [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse" [mWishlistData]="mWishlistData" ></app-product-box>
          </div>
        </div>
      </div>
      <!-- Listing START -->

    </div>
  </section>
  <div *ngIf="supplimentProducts.length < 1" class="no-record-text">
    <span>No Record Found!</span>
  </div>
  </div>
  <!-- Shop Main END -->


  <div *ngIf="productType == 'trending'">
  <section class="shop-main" *ngIf="trendingProducts && trendingProducts.length > 0">
    <div class="shop-wrap">

      <!-- Listing START -->
      <div class="services-lists">
        <div class="row" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100"
          (scrolled)="onScrollTrendingProduct()">
          <div class="col-md-3 col-sm-6 item" *ngFor="let trendingProduct of trendingProducts; let i = index">
          <app-product-box [color]="trendingProduct?.category?.color"  [product]="trendingProduct" [mAddUpdateCartModule]="mAddUpdateCartModule" [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse" [mWishlistData]="mWishlistData"></app-product-box>
        </div>
        </div>
      </div>
      <!-- Listing START -->
    </div>
  </section>
  <div *ngIf="trendingProducts.length < 1" class="no-record-text">
    <span>No Record Found!</span>
  </div>
  </div>
  
  <!-- Footer START -->

<div *ngIf="productType != 'trending' && productType != 'supplements'">
  <section class="shop-main" *ngIf="mWishlistData && mWishlistData.length > 0 && productType == 'wishlist'">
    <div class="shop-wrap">

      <!-- Listing START -->
      <div class="services-lists">
        <div class="row">
          <div  class="col-md-3 col-sm-6 item"  *ngFor="let wishList of mWishlistData; let i  = index">
            <app-product-box [color]="wishList?.productdetail?.category?.color" [product]="wishList" [mAddUpdateCartModule]="mAddUpdateCartModule" [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse" [mWishlistData]="mWishlistData"  [productType]="productType"></app-product-box>
          </div>
        </div>
      </div>
      <!-- Listing START -->

    </div>
  </section>
  <div *ngIf="mWishlistData.length < 1" class="no-record-text">
    <div class="row justify-content-center w-100">
      <div class="col-lg-4 col-12">
        <div class="empty-card">
          <div class="empty-card-icon">
            <img src="assets/images/wishlist-empty.svg" alt="icon">
          </div>
          <span>No items in your wishlist</span>
          <small>Add items to wishlist now!</small>
        </div>
        <a routerLink="/shop-all" class="start-btn">Add items to wishlist</a>
      </div>
    </div>
  </div>
</div>
  <!-- Footer END -->
</div>
<app-footer-bg></app-footer-bg>